import {SocialFooter} from "../components/common/CommonLayout";
import React from "react";
import {useAppDispatch} from "../components/common/Global";
import {setPageTitle} from "./common/NavigationState";
import {ContentBox} from "../components/ContentBox";
import {TextPanel} from "../components/TextPanel";
import {Link} from "@mui/material";

export const SupportUsPage = () => {
  const dispatch = useAppDispatch();
  dispatch(setPageTitle("Support Us"));

  return (
    <>
      <PatreonPanel />
      <AlgoPanel />
      <FeedbackPanel />
      <SocialFooter />
    </>
  );
};

const PatreonPanel = () => (
  <ContentBox image="ocarinas">
    <TextPanel
      flavor="We appreciate you so much!"
      title="Supporting OCWALK"
      description={
        <>
          Thank you so much for considering supporting the project! <br />
          Currently, you can support us by joining our Patreon. <br />
          We have free, $1 and $5 per month tiers - whichever you prefer!
        </>
      }
      align="left"
      primaryButtonTitle="Patreon"
      primaryButtonUrl="https://www.patreon.com/wispy"
    />
  </ContentBox>
);

const AlgoPanel = () => (
  <ContentBox image="vynil">
    <TextPanel
      flavor="Help people discover OCWALK"
      title="Algorithm"
      description={
        <>
          You could help ocarina learners discover OCWALK by engaging with our content. <br />
          Subscribe, like, comment on our YouTube channel - it really helps! <br />
          I also post the pixel art of the thumbnails on Bluesky, if you would like to follow :)
        </>
      }
      align="right"
      primaryButtonTitle="YouTube"
      primaryButtonUrl="https://www.youtube.com/@OcarinaWalk"
      secondaryButtonTitle="Bluesky"
      secondaryButtonUrl="https://bsky.app/profile/radiantwisp.bsky.social"
    />
  </ContentBox>
);

const FeedbackPanel = () => (
  <ContentBox image="generic">
    <TextPanel
      flavor="Your experience is important"
      title="Feedback"
      description={
        <>
          We would love to hear about your experience using OCWALK videos and website. <br />
          Please let us know if you had any struggles, or you have suggestions! <br />
          Email us: <Link href="mailto:owispyo@gmail.com">owispyo@gmail.com</Link>
        </>
      }
      align="left"
      primaryButtonTitle="Send Email"
      primaryButtonUrl="mailto:owispyo@gmail.com"
    />
  </ContentBox>
);
